import { render, staticRenderFns } from "./sysModule.vue?vue&type=template&id=b5261a84&"
import script from "./sysModule.vue?vue&type=script&lang=js&"
export * from "./sysModule.vue?vue&type=script&lang=js&"
import style0 from "./sysModule.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports